import { EvilIcons } from '@expo/vector-icons';
import React, { useState } from 'react';
import { Pressable, StatusBar, StyleSheet, Text, View } from 'react-native';

import DifficultyScreen from './components/Screens/Difficulty';
import OptionsScreen from './components/Screens/Options';
import QuestionsScreen from './components/Screens/Questions';
import Styles from './styles';
import Colors from './styles/Colors';
import { CalcVariants, Screens } from './types';

export default function App() {
  const [visibleScreen, setVisibleScreen] = useState<Screens>('start');
  const [questionTypes, setQuestionTypes] = useState<Array<CalcVariants>>([
    'plus',
    'minus',
    'times',
    'divide',
  ]);

  return (
    <>
      <StatusBar />
      {visibleScreen === 'start' && (
        <View style={Styles.container}>
          <Pressable
            style={[styles.startBtn, Styles.btn]}
            onPress={() => setVisibleScreen('options')}
          >
            <Text style={[styles.startBtnText, Styles.text]}>Start</Text>
          </Pressable>
          <Pressable
            style={[styles.startBtn, Styles.btn]}
            onPress={() => setVisibleScreen('difficulty')}
          >
            <Text style={[styles.startBtnText, Styles.text]}>Difficulty</Text>
          </Pressable>
          {/* <Pressable style={[styles.startBtn, Styles.btn]} onPress={() => true}>
            <Text style={[styles.startBtnText, Styles.text]}>Settings</Text>
          </Pressable> */}
        </View>
      )}
      {visibleScreen === 'questions' && (
        <QuestionsScreen questionTypes={questionTypes} />
      )}
      {visibleScreen === 'options' && (
        <OptionsScreen
          setVisibleScreen={setVisibleScreen}
          setQuestionTypes={setQuestionTypes}
        />
      )}
      {visibleScreen === 'difficulty' && <DifficultyScreen />}
      {visibleScreen !== 'start' && (
        <Pressable
          style={[styles.quitBtn]}
          onPress={() => setVisibleScreen('start')}
        >
          <EvilIcons name="close" color={Colors.text} size={40} />
        </Pressable>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  startBtn: {
    width: '80%',
    backgroundColor: Colors.buttonDark,
    height: 100,
  },
  startBtnText: {
    fontSize: 60,
  },
  quitBtn: {
    position: 'absolute',
    top: 5,
    left: 5,
  },
});
